import type { IETicketMedia } from '#/utils/eTicketMedia'
import type { TStatusGroup } from '#lib/statusGroups'
import type { TTicketType } from '#pages/ETickets/interfaces'

export type { IETicketMedia }

export const TRAVELLER_STATUSES = ['upcoming', 'today', 'expired', 'processing', 'failed'] as const

export type TTravellerStatus = (typeof TRAVELLER_STATUSES)[number]

export type TTravellerStatusFilter = 'all' | TTravellerStatus

export interface IMyETicket {
  id: string
  fromStationName: string
  toStationName: string
  trainClass: 1 | 2
  ticketType: TTicketType
  travelDate: string
  travelTime: string | null
  price: number | null
  travellerStatus: TTravellerStatus
  media: IETicketMedia[]
  tag: string | null
  deliveryMethod: 'wallet' | 'homeprint'
}

export const TRAVELLER_STATUS_VARIANT_MAP: Record<TTravellerStatus, TStatusGroup> = {
  upcoming: 'info',
  today: 'success',
  expired: 'neutral',
  processing: 'info',
  failed: 'danger',
}
